"use client";

import { Button } from '@/components/ui/button';
import { useCardStore } from '@/util/store/card';
import { ShowToast } from '@/util/view/ShowToast';
import { ReloadIcon } from '@radix-ui/react-icons';
import { FC } from 'react';

interface SellButtonProps {
    ProductId: number;
    ProductIdentityId: number;
    available: boolean;
    property?: { attr: string; property: string }[];
    loading?: boolean
}

const SellButton: FC<SellButtonProps> = ({ ProductId, ProductIdentityId, available, property = [], loading }) => {
    
    const { addCard, cart, deleteCard } = useCardStore();

    const isInCart = cart.some(c => c.ProductIdentityId === ProductIdentityId)

    const handleButtonClick = () => {
        if (isInCart) {
            deleteCard(ProductIdentityId);
            ShowToast("از سبد خرید حذف شد", "warning");
        } else {
            addCard({ count: 1, ProductId, ProductIdentityId, property });
            ShowToast("به سبد خرید اضافه شد", "success");
        }
    };

    return (
        <Button
            key={!available ? "not-available" : isInCart ? 'in-cart' : 'not-in-cart'}
            disabled={!available || loading}
            onClick={handleButtonClick}
            className="m-3"
            variant={!available ? "destructiveOut" : isInCart ? "successOutline" : "success"}
            aria-label={isInCart ? "Remove from cart" : "Add to cart"}
        >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 ml-2">
                <path strokeLinecap="round" strokeLinejoin="round" d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
            </svg>
            {loading ?
                <ReloadIcon className="mr-2 h-4 w-4 animate-spin" />
                : !available ? "رنگ یا سایز انتخاب کنید" : isInCart ? "در سبد خرید" : " افزودن به سبد خرید"}
        </Button>
    );
};

export default SellButton;
